type ResultsProps = {
    totalItems: number;
    currentPage: number;
    perPage: number;
};

export default function Results({
    totalItems,
    currentPage,
    perPage,
}: ResultsProps) {
    const itemStart = currentPage * perPage - perPage + 1;
    const itemEnd =
        currentPage * perPage > totalItems ? totalItems : currentPage * perPage;

    return (
        <div
            data-testid="pagination-results"
            className="alli-hidden md:alli-block">
            <p className="alli-text-sm alli-text-blue-gray-700">
                Showing{' '}
                <span className="alli-font-medium alli-text-blue-gray-700">
                    {itemStart}
                </span>{' '}
                to{' '}
                <span className="alli-font-medium alli-text-blue-gray-700">
                    {itemEnd}
                </span>{' '}
                of <span className="alli-font-medium">{totalItems}</span>{' '}
                results
            </p>
        </div>
    );
}
